import moment from 'moment';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import linearTy from '../../assets/img/linear_thankyou.svg';
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { LEndSection } from "../../components/styled/Containers.style";
import { LIconContainer } from '../../components/styled/Icon.style';
import { Vspace } from '../../components/styled/Separators.style';
import { LEndPageTitle, LEndText } from "../../components/styled/Text.style";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from '../../store';
import { useAppSelector } from '../../store/hooks';
import { EventValueEnum } from '../../types/communication/communicationDataType';
import { composeUrl } from '../../utils/utils';
import PageContainerCmp from "../PageContainerCmp";


const EndThankYouPageLinear = () => {

    const communicationData = useAppSelector(selectCommunicationData);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { communication } = communicationData;
    const { creation_date, token } = communication;
    const date = moment(creation_date).add(2, 'days').format("DD/MM/YYYY");
    const docParam = searchParams.get('doc');

    const weAlreadyHaveSignature = communication?.events?.find((ev: any) => ev.value === EventValueEnum.LINEAR_START_ONE_SIGNATURE)
    const weAskedForASignature = communication?.events?.find((ev: any) => [EventValueEnum.LINEAR_START_ONE_SIGNATURE, EventValueEnum.LINEAR_START_SIGNATURE_SEND_FOR_CTP_AUTH].includes(ev.value))

    useEffect(() => {
        if (!docParam) {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set('doc', 'true');
            setSearchParams(newSearchParams);
        }
        else {
            const nextPath = composeUrl(token, (weAlreadyHaveSignature || weAskedForASignature) ? LINEAR_PATHS.REQUIRE_DOCUMENTS_PAGE : LINEAR_PATHS.WELCOME_FIRST_PAGE, LINEAR_BASE_ROUTE);
            navigate(nextPath);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>

            <PageContainerCmp
                routePath={LINEAR_PATHS.END_THANK_YOU_PAGE}
                removeNextBtn
                eventsOnLoad={[EventValueEnum.LINEAR_SEND_DOCUMENTS, EventValueEnum.LINEAR_CONFIRM_STEPS_COMPLETED]}
            >
                <LEndSection>

                    <LIconContainer style={{ marginTop: "-220px" }}>
                        <img
                            src={linearTy}
                            alt="Grazie"
                            style={{ width: "250px" }}
                        />
                    </LIconContainer>

                    <LEndPageTitle>GRAZIE!</LEndPageTitle>
                    <Vspace qty={2}></Vspace>
                    <LEndText>L'invio dei documenti è andato a buon fine, ti aggiorniamo al più presto.</LEndText>
                    <Vspace qty={2}></Vspace>
                    <LEndText>{`Se non hai inviato tutti i documenti, puoi inviare quelli mancanti in un secondo momento partendo dal link ricevuto via sms entro il ${date}.`}</LEndText>
                </LEndSection>

                <LinearFooterCmp inverted={true} />

            </PageContainerCmp>
        </>

    )
}

export default EndThankYouPageLinear